<template>
  <div class="contact">
    <!-- Page top section -->
    <!-- <section class="page-top-section set-bg" data-setbg="img/page-top-bg/4.jpg">
      <div class="page-info">
        <h2>Contact</h2>
        <div class="site-breadcrumb">
          <a href>Home</a> /
          <span>Contact</span>
        </div>
      </div>
    </section>-->
    <!-- Page top end-->

    <!-- Contact page -->
    <section class="contact-page pb-5">
      <div class="container text-white">
        <h2>Onde irá ocorrer?</h2>
        <p class="pl-5 pr-5 pb-5 pt-3">
          O evento irá ocorrer no IFCE Campus Aracati e é totalmente gratuito. Com o mapa abaixo você pode ver e se informar melhor sobre o local de realização do evento e se planejar
          para chegar no local certo e no horário certo.
        </p>
        <div class="map">
          <iframe
            src="https://maps.google.com/maps?q=ifce%20aracati&t=&z=17&ie=UTF8&iwloc=&output=embed"
            style="border:0"
            allowfullscreen
          ></iframe>
        </div>
        <!-- <div class="row">
          <div class="col-lg-7 order-2 order-lg-1">
            <form class="contact-form">
              <input type="text" placeholder="Your name" />
              <input type="text" placeholder="Your e-mail" />
              <input type="text" placeholder="Subject" />
              <textarea placeholder="Message"></textarea>
              <button class="site-btn">
                Send message
                <img src="../assets/img/icons/double-arrow.png" alt="#" />
              </button>
            </form>
          </div>
          <div class="col-lg-5 order-1 order-lg-2 contact-text text-white">
            <h3>Howdy! Say hello</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.....</p>
            <div class="cont-info">
              <div class="ci-icon">
                <img src="../assets/img/icons/location.png" alt />
              </div>
              <div class="ci-text">Main Str, no 23, New York</div>
            </div>
            <div class="cont-info">
              <div class="ci-icon">
                <img src="../assets/img/icons/phone.png" alt />
              </div>
              <div class="ci-text">+546 990221 123</div>
            </div>
            <div class="cont-info">
              <div class="ci-icon">
                <img src="../assets/img/icons/mail.png" alt />
              </div>
              <div class="ci-text">hosting@contact.com</div>
            </div>
          </div>
        </div>-->
      </div>
    </section>
    <!-- Contact page end-->

    <!-- Newsletter section -->
    <!-- <section class="newsletter-section">
      <div class="container">
        <h2>Subscribe to our newsletter</h2>
        <form class="newsletter-form">
          <input type="text" placeholder="ENTER YOUR E-MAIL" />
          <button class="site-btn">
            subscribe
            <img src="../assets/img/icons/double-arrow.png" alt="#" />
          </button>
        </form>
      </div>
    </section>-->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.contact-page {
  padding-top: 120px;
}
</style>